import React, { useState } from 'react';
import { SimpleNavbar } from '../../components/layout/SimpleNavbar';
import { AuthButton } from '../../components/common/AuthButton';

export const ComingSoonPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Email submitted for early access:', email);
    setSubmitted(true);
  };

  const inputClass = "w-full px-5 py-4 rounded-xl bg-slate-700/50 backdrop-blur-md border border-slate-600/40 text-white focus:outline-none focus:ring-2 focus:ring-cyan-400/50 transition-all";

  if (submitted) {
    return (
      <div className="min-h-screen bg-common-gradient">
        <SimpleNavbar />

        <div className="flex items-center justify-center min-h-screen px-4">
          <div className="max-w-3xl w-full text-center">

            <h1 className="text-5xl font-anton text-white mb-12">
              THANK YOU!
            </h1>

            <div className="space-y-6">
              <p className="text-xl font-bold text-white">
                WE'VE RECEIVED YOUR EMAIL
              </p>

              <p className="text-base text-white leading-relaxed max-w-2xl mx-auto">
                WE'LL NOTIFY YOU AS SOON AS THIS FEATURE BECOMES AVAILABLE.
                <br />
                STAY TUNED FOR UPDATES!
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-common-gradient">
      <SimpleNavbar />

      <div className="flex items-center justify-center min-h-screen px-4 pt-24 pb-16">
        <div className="max-w-2xl w-full">

          <h1 className="text-5xl font-anton text-white text-center mb-8">
            COMING SOON
          </h1>

          <p className="text-center text-white text-lg mb-12">
            This feature is not available yet. Enter your email to receive updates when it launches.
          </p>

          <form onSubmit={handleSubmit} className="space-y-8">
            <div>
              <label className="block text-left text-white text-sm mb-3">Enter your e-mail</label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="your.email@example.com"
                className={inputClass}
              />
            </div>

            <AuthButton type="submit" className="w-full max-w-xs mx-auto block mt-10">
              NOTIFY ME
            </AuthButton>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
